<template>
    <np-skeleton v-if="!objectIsNotEmpty(outlet)" :type="'full_view'"></np-skeleton>
    <div v-else>
        <form @submit.prevent="submitPrevent" id="outlet_information_form"
              ref="outlet_information_form" class="content-inner formValidation">
            <div ref="outlet_block">
                <div class="row">
                    <div class="col-12">
                        <div class="panel-sub-heading headingSmall"><span
                                class="markedBottom">{{ lang('address') }}</span>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="col-md-6 col-12 ps-0">
                            <np-input ref="trading_name"
                                      :id="`outlet_trade_name`"
                                      :name="`outlet_trade_name`"
                                      :label="lang('store_name')"
                                      :required="true"
                                      v-model="outlet.trade_name">
                            </np-input>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row" ref="block_store_address">
                            <div class="col-md-6 col-12">
                                <np-postcode-search
                                        ref="store_address_zip_code"
                                        :name="'store_address_zip_code'"
                                        :id="'store_address_zip_code'"
                                        :label="lang('post_code')"
                                        :required="true"
                                        :minlength="5"
                                        :maxlength="10"
                                        :iso3="outlet.trading.country_code == '826' ? `GBR` : ``"
                                        v-model="outlet.trading.zip_code"
                                        @address-selected="updateAddress($event, outlet.trading)">
                                </np-postcode-search>
                                <np-input
                                        :name="'store_address_house_name'"
                                        :id="'store_address_house_name'"
                                        :label="lang('house_name')"
                                        :no-wrapper="false"
                                        :required="false"
                                        ref="store_address_house_name"
                                        v-model="outlet.trading.house_name">
                                </np-input>
                                <np-input
                                        :name="'store_address_city'"
                                        :id="'store_address_city'"
                                        :label="lang('field_town_city')"
                                        :no-wrapper="false"
                                        :rules="['valid_city_town']"
                                        ref="store_address_city"
                                        v-model="outlet.trading.city">
                                </np-input>

                            </div>
                            <div class="col-md-6 col-12">
                                <np-input
                                        :name="'store_address_street_line_1'"
                                        :id="'store_address_street_line_1'"
                                        :label="lang('field_street')"
                                        :no-wrapper="false"
                                        ref="store_address_street_line_1"
                                        v-model="outlet.trading.street_line_1">
                                </np-input>
                                <div v-if="outlet.trading.country_code === '840'">
                                    <np-select2
                                            :name="'store_address_county_code'"
                                            :id="'store_address_county_code'"
                                            :label="lang('state')"
                                            :no-wrapper="false"
                                            :required="false"
                                            ref="store_address_county_code"
                                            :parameters="parameters.STATES_PARAM"
                                            v-model="outlet.trading.county_code">
                                    </np-select2>
                                </div>
                                <div v-else>
                                    <np-input
                                            :name="'store_address_county_code'"
                                            :id="'store_address_county_code'"
                                            :label="lang('field_county_state')"
                                            :no-wrapper="false"
                                            :required="false"
                                            :rules="['alpha_space_dot']"
                                            v-country-dependent="[outlet.trading.country_code, 'county_code']"
                                            ref="store_address_county_code"
                                            v-model="outlet.trading.county_code">
                                    </np-input>
                                </div>
                                <np-select2
                                        :name="'store_address_country_code'"
                                        :id="'store_address_country_code'"
                                        :mode="`country`"
                                        :label="lang('country')"
                                        :parameters="parameters.COUNTRIES_PARAM"
                                        :no-wrapper="false"
                                        ref="store_address_country_code"
                                        v-model="outlet.trading.country_code">
                                </np-select2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" ref="trading_block">
                    <div class="col-md-6 col-12">
                        <div class="row">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall"><span
                                        class="markedBottom">{{ lang('trading') }}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <np-input
                                        :id="`outlet_merchant_category_${outlet_id}`"
                                        :name="`outlet_merchant_category[${outlet_id}]`"
                                        :label="lang('merchant_category_code')"
                                        v-model="outlet.merchant_category_code">
                                </np-input>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="row">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall"><span
                                        class="markedBottom">{{ lang('shipping_option') }}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <np-radios
                                        :id="`outlet_shipping_options_${outlet_id}`"
                                        :name="`outlet_shipping_options[${outlet_id}]`"
                                        :required="true"
                                        :hide-label="true"
                                        :options="shipping_options_params"
                                        v-model="outlet.shipping_option">
                                </np-radios>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="outlet.shipping_option ==='1'">
                    <div class="col-12">
                        <div class="panel-sub-heading headingSmall">
                            <span class="markedBottom">{{lang('shipping_address')}}</span>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row" ref="block_store_address">
                            <div class="col-md-6 col-12">
                                <np-postcode-search
                                        ref="store_address_zip_code"
                                        :name="'store_address_zip_code'"
                                        :id="'store_address_zip_code'"
                                        :label="lang('post_code')"
                                        :required="true"
                                        :minlength="5"
                                        :maxlength="10"
                                        :iso3="outlet.shipping.country_code == '826' ? `GBR` : ``"
                                        v-model="outlet.shipping.zip_code"
                                        @address-selected="updateAddress($event, outlet.shipping)">
                                </np-postcode-search>
                                <np-input
                                        :name="'store_address_house_name'"
                                        :id="'store_address_house_name'"
                                        :label="lang('house_name')"
                                        :no-wrapper="false"
                                        :required="false"
                                        ref="store_address_house_name"
                                        v-model="outlet.shipping.house_name">
                                </np-input>
                                <np-input
                                        :name="'store_address_city'"
                                        :id="'store_address_city'"
                                        :label="lang('field_town_city')"
                                        :no-wrapper="false"
                                        :rules="['valid_city_town']"
                                        ref="store_address_city"
                                        v-model="outlet.shipping.city">
                                </np-input>

                            </div>
                            <div class="col-md-6 col-12">
                                <np-input
                                        :name="'store_address_street_line_1'"
                                        :id="'store_address_street_line_1'"
                                        :label="lang('field_street')"
                                        :no-wrapper="false"
                                        ref="store_address_street_line_1"
                                        v-model="outlet.shipping.street_line_1">
                                </np-input>
                                <div v-if="outlet.shipping.country_code === '840'">
                                    <np-select2
                                            :name="'store_address_county_code'"
                                            :id="'store_address_county_code'"
                                            :label="lang('state')"
                                            :no-wrapper="false"
                                            :required="false"
                                            ref="store_address_county_code"
                                            :parameters="parameters.STATES_PARAM"
                                            v-model="outlet.shipping.county_code">
                                    </np-select2>
                                </div>
                                <div v-else>
                                    <np-input
                                            :name="'store_address_county_code'"
                                            :id="'store_address_county_code'"
                                            :label="lang('field_county_state')"
                                            :no-wrapper="false"
                                            :required="false"
                                            :rules="['alpha_space_dot']"
                                            v-country-dependent="[outlet.shipping.country_code, 'county_code']"
                                            ref="store_address_county_code"
                                            v-model="outlet.shipping.county_code">
                                    </np-input>
                                </div>
                                <np-select2
                                        :name="'store_address_country_code'"
                                        :id="'store_address_country_code'"
                                        :mode="`country`"
                                        :label="lang('country')"
                                        :parameters="parameters.COUNTRIES_PARAM"
                                        :no-wrapper="false"
                                        ref="store_address_country_code"
                                        v-model="outlet.shipping.country_code">
                                </np-select2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="panel-sub-heading headingSmall"><span
                                class="markedBottom">{{lang('shipping_contact')}}</span>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <np-select2
                                :name="'shipping_contact_title'"
                                :id="'shipping_contact_title'"
                                :label="lang('field_title')"
                                :placeholder="lang('field_title')"
                                :parameters="parameters.TITLES"
                                :no-wrapper="false"
                                ref="shipping_contact_title"
                                v-model="outlet.shipping.contact_title">
                        </np-select2>
                        <np-input
                                :name="'shipping_contact_first_name'"
                                :id="'shipping_contact_first_name'"
                                :label="lang('field_first_name')"
                                :no-wrapper="false"
                                :rules="['alpha_name']"
                                :maxlength="getFirstNameMaxLengthByIso3('max')"
                                ref="shipping_contact_first_name"
                                v-model="outlet.shipping.contact_first_name">
                        </np-input>
<!--                        <np-input-->
<!--                                :name="'shipping_contact_second_name'"-->
<!--                                :id="'shipping_contact_second_name'"-->
<!--                                :label="lang('field_middle_name')"-->
<!--                                :no-wrapper="false"-->
<!--                                :rules="['alpha_numeric_space']"-->
<!--                                :maxlength="25"-->
<!--                                :required="false"-->
<!--                                ref="shipping_contact_second_name"-->
<!--                                v-model="outlet.shipping.contact_second_name">-->
<!--                        </np-input>-->
                        <np-input
                                :name="'shipping_contact_email_address'"
                                :id="'shipping_contact_email_address'"
                                :label="lang('email')"
                                :no-wrapper="false"
                                :rules="['valid_email']"
                                :maxlength="50"
                                ref="shipping_contact_email_address"
                                v-model="outlet.shipping.email_address">
                        </np-input>
                    </div>
                    <div class="col-md-6 col-12">
                        <np-input
                                :name="'shipping_contact_last_name'"
                                :id="'shipping_contact_last_name'"
                                :label="lang('field_last_name')"
                                :no-wrapper="false"
                                :rules="['alpha_name']"
                                :maxlength="25"
                                ref="shipping_contact_last_name"
                                v-model="outlet.shipping.contact_last_name">
                        </np-input>
                        <div class="row compactInputFormat" ref="shipping_contact_phone">
                            <div class="col-12 col-md-12">
                                <label>{{lang('phone')}}</label>
                            </div>
                            <div class="col-5">
                                <np-select2
                                        :name="'shipping_contact_phone_code'"
                                        :id="'shipping_contact_phone_code'"
                                        :placeholder="lang('phone_code')"
                                        :no-wrapper="true"
                                        :mode="`phone`"
                                        :required="true"
                                        ref="shipping_contact_phone_code"
                                        :parameters="parameters.PHONE_CODES"
                                        v-model="outlet.shipping.ent_telephone_code">
                                </np-select2>
                            </div>
                            <div class="col-7">
                                <np-phone ref="shipping_contact_phone_no"
                                          :name="'shipping_contact_phone_no'"
                                          :id="'shipping_contact_phone_no'"
                                          :no-wrapper="true"
                                          :label="lang('phone_number')"
                                          :rules="['numeric', 'phone_no_leading_zero']"
                                          :maxlength="10"
                                          :phone-code="outlet.shipping.ent_telephone_code"
                                          v-model="outlet.shipping.telephone_number">
                                </np-phone>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="banks" ref="outlet_bank_block" v-if="merchant.bank_relationship === 'OUTLET'">
                    <div class="col-12">
                        <div class="panel-sub-heading headingSmall">
                            <span class="markedBottom">{{ lang('banks') }}</span>
                        </div>
                    </div>
                    <div class="col-md-6 col-12" v-for="(bank, bank_idx) in outlet.banks" :key="bank_idx">
                        <div class="card">
                            <div class="card-header">
                                <span>{{lang(bank.bank_account_type)}}</span>
                                <np-checkbox class="float-right float-end"
                                             v-if="bank.bank_account_type === 'BILLING'"
                                             :id="`checking_account_as_deposit`"
                                             :name="`checking_account_as_deposit`"
                                             ref="billing_same_as_deposit_bank"
                                             @change="copyDepositToBilling"
                                             :description="lang('same_as_deposit_bank')"
                                             :value="'1'"
                                             :no-wrapper="true"
                                             v-model="bank.copy_other_account">
                                </np-checkbox>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-6 col-md-12 col-12">
                                        <np-input :id="`bank_sort_code_${bank_idx}`"
                                                  :name="`bank_sort_code_${bank_idx}`"
                                                  :label="lang('sort_code')"
                                                  :rules="['integer']"
                                                  @input="validateBank(bank)"
                                                  v-model="bank.sort_code">
                                        </np-input>
                                        <np-input :id="`bank_account_number_${bank_idx}`"
                                                  :name="`bank_account_number_${bank_idx}`"
                                                  :label="lang('account_number')"
                                                  :rules="['integer']"
                                                  @input="validateBank(bank)"
                                                  v-model="bank.account_number">
                                        </np-input>
                                    </div>
                                    <div class="col-lg-6 col-md-12 col-12">
                                        <div class="card">
                                            <!--                                   TODO get the height of the form div and make this card match or be horizontally centered.-->
                                            <div class="card-body py-0">
                                                 <span>{{bank.bank_name}} <br>{{bank.street_line_1}} <br>
                                                   {{`${bank.bank_city},`}} {{`${bank.county_code},`}}
                                                   <br>{{`${bank.zip_code},`}}
                                                   <br> {{formatCountry(bank.country_code)}}
                                               </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="panel-sub-heading headingSmall">
                            <span class="markedBottom">{{ lang('equipments') }}</span>
                        </div>
                    </div>
                    <div class="col-12">

                    </div>
                </div>
            </div>

        </form>
    </div>
</template>

<script>
    import {mapState} from "pinia";
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal, NPPhone, NPPostcodeSearch,
        NPRadios, NPResponsive,
        NPSelect2, NPSkeleton,
        NPTextArea, NPVat
    } from "netpify/components";
    import {Outlet} from "../../../../entities";
    import utilMixin from "../../../../utils/mixins";
    import applicationMixin from "../../../../utils/application-mixin";
    import useApplicationStore from "../../../../stores/application_module";

    export default {
        name: "SingleOutlet",
        mixins:[utilMixin, applicationMixin],
        components: {
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
        },
        data() {
            return {
                outlet: new Outlet(),
                outlet_changed: false,
                copy_deposit_account: '',
                shipping_options_params: [
                    {
                        label: this.lang('select_equipment_to_this_store'),
                        value: '0',
                    },
                    {
                        label: this.lang('ship_to_different_address'),
                        value: '1'
                    }
                ],
            }
        },
        computed: {
            ...mapState(useApplicationStore, {outletInFocus:'outletInFocus'}),
            outlet_id: function (){
              return this.$route.params.outlet_ref;
            },
        },
        // beforeRouteUpdate(to, from, next) {
        //     this.setOutlet();
        //     next();
        // },
        mounted() {
            //console.log('mounted')
            //console.log(this.outletInFocus)
            this.setOutlet()
        },
        methods: {
            setOutlet: function () {
                this.outlet = this.outletInFocus;
                $('[id*="outlet_information_"] *').removeClass('has-error');
                $('[id*="outlet_information_"]').formValidator({
                    //triggerElement: '.sendForm', //trigger element default $('form').find('button[type="submit"]')
                    triggerEvent: '', // event - default 'click'
                    defaultConfig: '', // {} - object to set different configuration in validate.js
                    scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                    additionalCallbackFunction: function () {

                    }//you can pass here additional function which will be called before send form (function should return boolean) default ''
                })
            },
            setOutletBank: function () {
                if (data === 'OUTLET'){
                    this.outlet.forEach(obj => {

                    })
                }
            },
            updateAddress: function (data, target) {

                let keyMap = {
                    zip_code: 'postcode',
                    house_name: 'buildingName',
                    house_number: 'buildingNumber',
                    street_line_1: 'street',
                    locality: 'locality',
                    city: 'city',
                    county_code: 'county',
                };
                Object.entries(keyMap).forEach(([key, value]) => {
                    target[key] = data[value];
                });
                target['country_code'] = this.baseCountryCode;
            },
            copyDepositToBilling: function (event) {
                let deposit = this.outlet.banks.find(obj => {
                    return obj.bank_account_type === 'DEPOSIT'
                })

                this.outlet.banks.map(obj => {
                    if (obj.bank_account_type === 'BILLING') {
                        obj = deposit;
                    }
                    return obj
                })
            },
            validateBank: function (bank) {
                if (!!bank.sort_code && bank.account_number) {
                    //TODO validate and get account details.
                }
            },
            saveOutlet: function (next_page = false, validate = false) {

            }
        },
        watch: {
            '$route.params.outlet_ref': function (val, oldVal) {
                //console.log(val)
                //console.log(oldVal)
                if (val !== oldVal && !!val) {
                    this.setOutlet();
                }
            },
            'outletInFocus': {
                handler: function (newData, oldData) {
                    if (!!newData && (newData.outlet_external_id == oldData.outlet_external_id)) {
                        this.outlet_changed = true;
                        this.setOutlet();
                    }
                },
                deep: true
            }
        },

        beforeRouteLeave(to, from, next) {
            if (this.outlet_changed) {
                let validate = false;
                this.saveOutlet(false, validate);
            }
            next();
        }

    }
</script>

<style scoped>

</style>
